export const SIDE_NAV = {
  photo_report: {
    uk: "Фото звіт",
    en: "Photo report",
    hy: "Լուսանկարի հաշվետվություն",
    ka: "ფოტო ანგარიში",
  },
  all_reports: {
    uk: "BI звіти",
    en: "BI reports",
    hy: "BI հաշվետվություններ",
    ka: "BI ანგარიშები",
  },
  merchandiser: {
    uk: "Мерчендайзер",
    en: "Merchandiser",
    hy: "Մերչենդայզեր",
    ka: "მერჩენდაიზერი",
  },
  supervisors: {
    uk: "Супервайзери",
    en: "Supervisors",
    hy: "Սուպերվայզերներ",
    ka: "სუპერვაიზერები",
  },
  tasks: {
    uk: "Завдання",
    en: "Tasks",
    hy: "Առաջադրանքներ",
    ka: "დავალებები",
  },
  my_uploads: {
    uk: "Мої завантаження",
    en: "My Uploads",
    hy: "Իմ վերբեռնումները",
    ka: "ჩემი ატვირთვები",
  },
  answers: {
    uk: "Відповіді",
    en: "Answers",
    hy: "Պատասխաններ",
    ka: "პასუხები",
  },
  task_uploading: {
    uk: "Завантаження завдань",
    en: "Task uploading",
    hy: "Առաջադրանքների վերբեռնում",
    ka: "დავალებების ატვირთვა",
  },
  points: {
    uk: "Точки",
    en: "Points",
    hy: "Կետեր",
    ka: "წერტილები",
  },
  visit: {
    uk: "Візити",
    en: "Visits",
    hy: "Այցեր",
    ka: "ვიზიტები",
  },
  documents: {
    uk: "Документи",
    en: "Documents",
    hy: "Փաստաթղթեր",
    ka: "დოკუმენტები",
  },
  logout: {
    uk: "Вихід",
    en: "Logout",
    hy: "Դուրս գալ",
    ka: "გამოსვლა",
  },
  pt_points: {
    uk: "Точки",
    en: "Points",
    hy: "Կետեր",
    ka: "წერტილები",
  },
  pt_networks: {
    uk: "Мережі",
    en: "Networks",
    hy: "Ցանցեր",
    ka: "ქსელები",
  },
  pt_categories: {
    uk: "Категорії",
    en: "Categories",
    hy: "Կատեգորիաներ",
    ka: "კატეგორიები",
  },
  pt_countries: {
    uk: "Країни",
    en: "Countries",
    hy: "Երկրներ",
    ka: "ქვეყნები",
  },
  pt_counties: {
    uk: "Регіони",
    en: "Counties",
    hy: "Մարզեր",
    ka: "რეგიონები",
  },
  pt_localities: {
    uk: "Населені пункти",
    en: "Localities",
    hy: "Բնակավայրեր",
    ka: "დასახლებები",
  },
  pt_point_groups: {
    uk: "Групи точок",
    en: "Point groups",
    hy: "Կետերի խմբեր",
    ka: "წერტილების ჯგუფები",
  },
};
export const MANAGER_PROFILE = {
  my_profile: {
    uk: "Мій профайл",
    en: "My profile",
    hy: "Իմ պրոֆիլը",
    ka: "ჩემი პროფილი",
  },
  my_help: {
    uk: "Допомога",
    en: "Help",
    hy: "Օգնություն",
    ka: "დახმარება",
  },
  name: {
    uk: "Імя",
    en: "Name",
    hy: "Անուն",
    ka: "სახელი",
  },
  surname: {
    uk: "Прізвище",
    en: "Surname",
    hy: "Ազգանուն",
    ka: "გვარი",
  },
  position: {
    uk: "Посада",
    en: "Position",
    hy: "Պաշտոն",
    ka: "პოზიცია",
  },
  my_region: {
    uk: "Мій регіон",
    en: "My region",
    hy: "Իմ մարզը",
    ka: "ჩემი რეგიონი",
  },
  telegram: {
    uk: "Телеграм ID",
    en: "Telegram ID",
    hy: "Տելեգրամ ID",
    ka: "ტელეგრამ ID",
  },
  language: {
    uk: "Мова",
    en: "Language",
    hy: "Լեզու",
    ka: "ენა",
  },
  save: {
    uk: "Зберегти",
    en: "Save",
    hy: "Պահպանել",
    ka: "შენახვა",
  },
  save_success: {
    uk: "Дані успішно збережені",
    en: "Data saved successfully",
    hy: "Տվյալները հաջողությամբ պահպանվեցին",
    ka: "მონაცემები წარმატებით შენახულია",
  },
  save_success_reload: {
    uk: "Дані успішно збережені. Сторінка буде перезавантажена...",
    en: "Data saved successfully. The page will be reloaded...",
    hy: "Տվյալները հաջողությամբ պահպանվեցին։ Էջը կվերբեռնվի...",
    ka: "მონაცემები წარმატებით შენახულია. გვერდი გადაიტვირთება...",
  },
  exit: {
    uk: "Вихід",
    en: "Logout",
    hy: "Դուրս գալ",
    ka: "გამოსვლა",
  },
};
export const ENTITY_DROPDOWN_SETTINGS = {
  custom_filter: {
    uk: "Користувацький фільтр",
    en: "Customer filter",
    hy: "Հատուկ ֆիլտր",
    ka: "მორგებული ფილტრი",
  },
  merchandiser: {
    uk: "Мерчендайзер",
    en: "Merchandiser",
    hy: "Մերչենդայզեր",
    ka: "მერჩენდაიზერი",
  },
  merchandisers: {
    uk: "Мерчендайзери",
    en: "Merchandisers",
    hy: "Մերչենդայզերներ",
    ka: "მერჩენდაიზერები",
  },
  supervisor: {
    uk: "Супервайзер",
    en: "Supervisor",
    hy: "Սուպերվայզեր",
    ka: "სუპერვაიზერი",
  },
  clients: {
    uk: "Клієнти",
    en: "clients",
    hy: "հաճախորդներ",
    ka: "კლიენტები",
  },
  comment: {
    uk: "Коментар ...",
    en: "Comment ...",
    hy: "Մեկնաբանություն ...",
    ka: "კომენტარი ...",
  },
  point: {
    uk: "Точка",
    en: "Point",
    hy: "Կետ",
    ka: "წერტილი",
  },
  points: {
    uk: "Точки",
    en: "Points",
    hy: "Կետեր",
    ka: "წერტილები",
  },
  group_point_select_placeholder: {
    uk: "Група точок",
    en: "Group of points",
    hy: "Կետերի խումբ",
    ka: "წერტილების ჯგუფი",
  },
  network: {
    uk: "Мережа",
    en: "Network",
    hy: "Ցանց",
    ka: "ქსელი",
  },
  networks: {
    uk: "Мережі",
    en: "Networks",
    hy: "Ցանցեր",
    ka: "ქსელები",
  },
  created_by: {
    uk: "Ким створено",
    en: "Created by",
    hy: "Ստեղծել է",
    ka: "შემქმნელი",
  },
  region: {
    uk: "Регіон",
    en: "Region",
    hy: "Մարզ",
    ka: "რეგიონი",
  },
  city: {
    uk: "Місто",
    en: "City",
    hy: "Քաղաք",
    ka: "ქალაქი",
  },
  country: {
    uk: "Оберіть країну",
    en: "Select country",
    hy: "Ընտրեք երկիրը",
    ka: "აირჩიეთ ქვეყანა",
  },
  countries: {
    uk: "Оберіть країну",
    en: "Select country",
    hy: "Ընտրեք երկիրը",
    ka: "აირჩიეთ ქვეყანა",
  },
  brand: {
    uk: "Бренд",
    en: "Brand",
    hy: "Բրենդ",
    ka: "ბრენდი",
  },
  brands: {
    uk: "Бренди",
    en: "Brands",
    hy: "Բրենդներ",
    ka: "ბრენდები",
  },
  product: {
    uk: "Продукт",
    en: "Product",
    hy: "Ապրանք",
    ka: "პროდუქტი",
  },
  products: {
    uk: "Продукти",
    en: "Products",
    hy: "Ապրանքներ",
    ka: "პროდუქტები",
  },
  category: {
    uk: "Категорія",
    en: "Category",
    hy: "Կատեգորիա",
    ka: "კატეგორია",
  },
  categories: {
    uk: "Категорії",
    en: "Сategories",
    hy: "Կատեգորիաներ",
    ka: "კატეგორიები",
  },
  subcategories: {
    uk: "Підкатегорія",
    en: "Sub category",
    hy: "Ենթակատեգորիա",
    ka: "ქვეკატეგორია",
  },
  tag: {
    uk: "Тег",
    en: "Tag",
    hy: "Թեգ",
    ka: "ტეგი",
  },
  tags: {
    uk: "Теги",
    en: "Tags",
    hy: "Թեգեր",
    ka: "ტეგები",
  },
  component: {
    uk: "Компонент",
    en: "Сomponent",
    hy: "Բաղադրիչ",
    ka: "კომპონენტი",
  },
  template: {
    uk: "Шаблон",
    en: "Template",
    hy: "Ձևանմուշ",
    ka: "შაბლონი",
  },
  task_status: {
    uk: "Статус: всі",
    en: "Status: all",
    hy: "Կարգավիճակ՝ բոլորը",
    ka: "სტატუსი: ყველა",
  },
  task_negative: {
    uk: "Негативна відповідь",
    en: "Negative answer",
    hy: "Բացասական պատասխան",
    ka: "უარყოფითი პასუხი",
  },
  task_deadline: {
    uk: "Дедлайн",
    en: "Deadline",
    hy: "Դեդլայն",
    ka: "დედლაინი",
  },
  additional_filters: {
    uk: "Додаткові фільтри",
    en: "Additional filters",
    hy: "Լրացուցիչ ֆիլտրեր",
    ka: "დამატებითი ფილტრები",
  },
  apply: {
    uk: "Застосувати",
    en: "Apply",
    hy: "Կիրառել",
    ka: "გამოყენება",
  },
  filter_reset: {
    uk: "Скинути фільтри",
    en: "Reset the filters",
    hy: "Զրոյացնել ֆիլտրերը",
    ka: "ფილტრების გადატვირთვა",
  },
  filter_save: {
    uk: "Зберегти фільтр",
    en: "Save the filter",
    hy: "Պահպանել ֆիլտրը",
    ka: "ფილტრის შენახვა",
  },
  filter_remove: {
    uk: "Видалити фільтр",
    en: "Remove the filter",
    hy: "Հեռացնել ֆիլտրը",
    ka: "ფილტრის წაშლა",
  },
  filter_name_placeholder: {
    uk: "Назва фільтру",
    en: "Filter name",
    hy: "Ֆիլտրի անվանում",
    ka: "ფილტრის სახელი",
  },
  date_range: {
    uk: "Виберіть період",
    en: "Select a certain period",
    hy: "Ընտրեք ժամանակահատված",
    ka: "აირჩიეთ პერიოდი",
  },
  date_today: {
    uk: "Сьогодні",
    en: "Today",
    hy: "Այսօր",
    ka: "დღეს",
  },
  date_yesterday: {
    uk: "Вчора",
    en: "Yesterday",
    hy: "Երեկ",
    ka: "გუშინ",
  },
  date_current_week: {
    uk: "Поточний тиждень",
    en: "Current week",
    hy: "Ընթացիկ շաբաթ",
    ka: "მიმდინარე კვირა",
  },
  date_last_week: {
    uk: "Попередній тиждень",
    en: "Last week",
    hy: "Անցած շաբաթ",
    ka: "გასული კვირა",
  },
  date_сurrent_month: {
    uk: "Поточний місяць",
    en: "Current month",
    hy: "Ընթացիկ ամիս",
    ka: "მიმდინარე თვე",
  },
  date_last_month: {
    uk: "Попередній місяць",
    en: "Last month",
    hy: "Անցած ամիս",
    ka: "გასული თვე",
  },
  date_last_half_year: {
    uk: "Останні пів року",
    en: "Last half a year",
    hy: "Վերջին կես տարի",
    ka: "ბოლო ნახევარი წელი",
  },
  photo_review_type_group: {
    uk: "Груповий вигляд",
    en: "View Group",
    hy: "Խմբային տեսք",
    ka: "ჯგუფური ხედი",
  },
  photo_review_type_single: {
    uk: "Індивідуальний вигляд",
    en: "View Single",
    hy: "Անհատական տեսք",
    ka: "ინდივიდუალური ხედი",
  },
};
export const TRANSLATION_DOWNLOADER = {
  export: {
    uk: "Експортувати",
    en: "Export",
    hy: "Արտահանել",
    ka: "ექსპორტი",
  },
  download: {
    uk: "Скачати",
    en: "Download",
    hy: "Ներբեռնել",
    ka: "ჩამოტვირთვა",
  },
  downloadAll: {
    uk: "Скачати всі",
    en: "Download All",
    hy: "Ներբեռնել բոլորը",
    ka: "ჩამოტვირთე ყველა",
  },
  downloading: {
    uk: "Завантаження",
    en: "Downloading",
    hy: "Ներբեռնվում է",
    ka: "ჩამოტვირთვა მიმდინარეობს",
  },
  confirmation_msg: {
    uk: "Ви впевненні що хочете видалити фільтр?",
    en: "Are you sure that you want to delete the filter?",
    hy: "Համոզված եք, որ ցանկանում եք ջնջել ֆիլտրը?",
    ka: "დარწმუნებული ხართ, რომ გსურთ წაშალოთ ფილტრი?",
  },
  remove_confirmation_msg: {
    uk: "Потрібно вибрати фільтр для видалення",
    en: "Need to select a filter to delete",
    hy: "Ջնջելու համար անհրաժեշտ է ընտրել ֆիլտր",
    ka: "წასაშლელად საჭიროა ფილტრის შერჩევა",
  },
  remove_success_msg: {
    uk: "Фільтр видалений",
    en: "The filter is deleted",
    hy: "Ֆիլտրը ջնջված է",
    ka: "ფილტრი წაშლილია",
  },
  valid_error_msg: {
    uk: "Ім'я фільтра не може бути пустим!",
    en: "The filter's name cannot be empty!",
    hy: "Ֆիլտրի անունը չի կարող դատարկ լինել!",
    ka: "ფილტრის სახელი არ შეიძლება იყოს ცარიელი!",
  },
  newtask_success_msg: {
    uk: "Завдання зберeжене",
    en: "The task is saved",
    hy: "Առաջադրանքը պահպանված է",
    ka: "დავალება შენახულია",
  },

  task_object_item_id_msg: {
    uk: "object_id або object_type не знайдені",
    en: "object_id or object_type not found",
    hy: "object_id կամ object_type չի գտնվել",
    ka: "object_id ან object_type ვერ მოიძებნა",
  },
  task_reject_msg: {
    uk: "Відхиленно",
    en: "Rejection",
    hy: "Մերժում",
    ka: "უარყოფა",
  },
  task_accept_msg: {
    uk: "Затвердженно",
    en: "Approval",
    hy: "Հաստատում",
    ka: "დამტკიცება",
  },
  back: {
    uk: "Назад",
    en: "Back",
    hy: "Հետ",
    ka: "უკან",
  },
  yes: {
    uk: "Так",
    en: "Yes",
    hy: "Այո",
    ka: "დიახ",
  },
  cancel: {
    uk: "Відмінити",
    en: "Cancel",
    hy: "Չեղարկել",
    ka: "გაუქმება",
  },
};
export const ENTITY_TABLE = {
  records_count: {
    uk: "Кількість записів",
    en: "Records count",
    hy: "Գրառումների քանակ",
    ka: "ჩანაწერების რაოდენობა",
  },
  start_date: {
    uk: "Дата початку",
    en: "Start date",
    hy: "Մեկնարկի ամսաթիվ",
    ka: "დაწყების თარიღი",
  },
  deadline_date: {
    uk: "Дата дедлайна",
    en: "Deadline date",
    hy: "Ավարտի ժամկետ",
    ka: "ვადის თარიღი",
  },
  filter_overdue_tasks: {
    uk: "Відфільтрувати простроковані задачі",
    en: "Filter overdue tasks",
    hy: "Զտել ուշացած առաջադրանքները",
    ka: "ვადაგადაცილებული დავალებების ფილტრი",
  },
  filter_tasks_with_negative_responses: {
    uk: "Відфільтрувати задачі з негативними відповідями",
    en: "Filter tasks with negative responses",
    hy: "Զտել բացասական պատասխաններով առաջադրանքները",
    ka: "უარყოფითი პასუხების მქონე დავალებების ფილტრი",
  },
  creation_date_from: {
    uk: "Дата створення з",
    en: "Creation date from",
    hy: "Ստեղծման ամսաթիվը սկսած",
    ka: "შექმნის თარიღი დან",
  },
  creation_date_to: {
    uk: "Дата створення по",
    en: "Creation date to",
    hy: "Ստեղծման ամսաթիվը մինչև",
    ka: "შექმნის თარიღი მდე",
  },
  search_placeholder: {
    uk: "Пошук ...",
    en: "Search ...",
    hy: "Որոնում ...",
    ka: "ძიება ...",
  },
  filter_reset_btn: {
    uk: "Скинути фільтри",
    en: "Reset filters",
    hy: "Զրոյացնել զտիչները",
    ka: "ფილტრების გადატვირთვა",
  },
  create_btn: {
    uk: "Створити",
    en: "Create",
    hy: "Ստեղծել",
    ka: "შექმნა",
  },
  to_point_btn: {
    uk: "на точку",
    en: "to point",
    hy: "դեպի կետ",
    ka: "წერტილზე",
  },
  to_network_btn: {
    uk: "на мережу",
    en: "to network",
    hy: "դեպի ցանց",
    ka: "ქსელზე",
  },
  apply_btn: {
    uk: "Застосувати",
    en: "Apply",
    hy: "Կիրառել",
    ka: "გამოყენება",
  },
};
export const MERCHANDISER_EDITOR = {
  name: {
    uk: "Імя",
    en: "Name",
    hy: "Անուն",
    ka: "სახელი",
  },
  date_of_enrollment: {
    uk: "Дата приєднання",
    en: "Date of joining",
    hy: "Միանալու ամսաթիվ",
    ka: "გაწევრიანების თარიღი",
  },
  deactivation_date: {
    uk: "Дата деактивації",
    en: "Deactivation date",
    hy: "Ապաակտիվացման ամսաթիվ",
    ka: "დეაქტივაციის თარიღი",
  },
  date_till_newbie: {
    uk: "Дата до новачка",
    en: "Date till newbie",
    hy: "Ամսաթիվ մինչև նորեկի կարգավիճակի ավարտը",
    ka: "თარიღი დამწყების სტატუსის დასრულებამდე",
  },
  surname: {
    uk: "Прізвище",
    en: "Surname",
    hy: "Ազգանուն",
    ka: "გვარი",
  },
  phone_number: {
    uk: "Телефон",
    en: "Phone number",
    hy: "Հեռախոսահամար",
    ka: "ტელეფონის ნომერი",
  },
  movement: {
    uk: "Пересування",
    en: "Movement",
    hy: "Տեղաշարժ",
    ka: "მოძრაობა",
  },
  password: {
    uk: "Пароль",
    en: "Password",
    hy: "Գաղտնաբառ",
    ka: "პაროლი",
  },
  repeat_password: {
    uk: "Повторити пароль",
    en: "Repeat password",
    hy: "Կրկնել գաղտնաբառը",
    ka: "გაიმეორეთ პაროლი",
  },
  status: {
    uk: "Статус",
    en: "Status",
    hy: "Կարգավիճակ",
    ka: "სტატუსი",
  },
  save_changes_btn: {
    uk: "Зберегти зміни",
    en: "Save changes",
    hy: "Պահպանել փոփոխությունները",
    ka: "ცვლილებების შენახვა",
  },
};
export const MERCHANDISER_MAIN_PAGE = {
  data_successfully_saved: {
    uk: "Дані успішно збережені",
    en: "Data successfully saved",
    hy: "Տվյալները հաջողությամբ պահպանվեցին",
    ka: "მონაცემები წარმატებით შენახულია",
  },
  view_btn: {
    uk: "Перегляд",
    en: "View",
    hy: "Դիտել",
    ka: "ნახვა",
  },
  edit_btn: {
    uk: "Редагувати",
    en: "Edit",
    hy: "Խմբագրել",
    ka: "რედაქტირება",
  },
  "routes": {
    uk: "Maршрути",
    en: "Routes",
    hy: "Մարքուտներ",
    ka: "მარშრუტები",
  },
  route: {
    uk: "Маршрут",
    en: "Route",
    hy: "Երթուղի",
    ka: "მარშრუტი",
  },
  assignment: {
    uk: "Завдання",
    en: "Assignment",
    hy: "Առաջադրանք",
    ka: "დავალება",
  },
  visits: {
    uk: "Вiзити",
    en: "Visits",
    hy: "ԱՅՑԵՐ",
    ka: "ვიზიტები",
  },
  presence: {
    uk: "Відсутність",
    en: "Absence",
    hy: "ՆԵՐԿԱՅՈՒԹՅՈՒՆ",
    ka: "დასწრება",
  },
  network_title: {
    uk: "Мережа",
    en: "Network",
    hy: "Ցանց",
    ka: "ქსელი",
  },
  title_title: {
    uk: "Титул",
    en: "Title",
    hy: "Տիտղոս",
    ka: "სათაური",
  },
  start_title: {
    uk: "Срт",
    en: "Start",
    hy: "Սկիզբ",
    ka: "დაწყება",
  },
  end_title: {
    uk: "Кінець",
    en: "End",
    hy: "Ավարտ",
    ka: "დასასრული",
  },
  number_of_images_title: {
    uk: "Кількість зображень",
    en: "Number of images",
    hy: "Նկարների քանակ",
    ka: "სურათების რაოდენობა",
  },
  number_of_tags_title: {
    uk: "Кількість тегів",
    en: "Number of tags",
    hy: "Թեգերի քանակ",
    ka: "ტეგების რაოდენობა",
  },
  completion_title: {
    uk: "Закінчення",
    en: "Completion",
    hy: "Ավարտում",
    ka: "დასრულება",
  },
  point_title: {
    uk: "Точка",
    en: "Point",
    hy: "Կետ",
    ka: "წერტილი",
  },
  points_title: {
    uk: "Точки",
    en: "Points",
    hy: "Կետեր",
    ka: "წერტილები",
  },
  day_title: {
    uk: "День",
    en: "Day",
    hy: "Օր",
    ka: "დღე",
  },
  save_btn: {
    uk: "Зберегти",
    en: "Save",
    hy: "Պահպանել",
    ka: "შენახვა",
  },
  movement: {
    uk: "Пересування",
    en: "Movement",
    hy: "Տեղաշարժ",
    ka: "მოძრაობა",
  },
  connected: {
    uk: "Приєднався",
    en: "Connected",
    hy: "Միացված",
    ka: "დაკავშირებული",
  },
  deactivated: {
    uk: "Деактивований",
    en: "Deactivated",
    hy: "Ապաակտիվացված",
    ka: "დეაქტივირებული",
  },
  till_newbie: {
    uk: "До новачків",
    en: "Till Newbie",
    hy: "Մինչև նորեկ",
    ka: "დამწყებამდე",
  },
  user_status: {
    uk: "Статус",
    en: "Status",
    hy: "Կարգավիճակ",
    ka: "სტატუსი",
  },
};
export const MERCHANDISER_LIST = {
  user_name: {
    uk: "Ім'я користувача",
    en: "User name",
    hy: "Օգտատիրոջ անունը",
    ka: "მომხმარებლის სახელი",
  },
  phone_number: {
    uk: "Телефон",
    en: "Phone",
    hy: "Հեռախոս",
    ka: "ტელეფონი",
  },
  movement: {
    uk: "Пересування",
    en: "Movement",
    hy: "Տեղաշարժ",
    ka: "მოძრაობა",
  },
  user_state: {
    uk: "Стан",
    en: "User State",
    hy: "Օգտատիրոջ կարգավիճակ",
    ka: "მომხმარებლის მდგომარეობა",
  },
  date_join: {
    uk: "Дата приєднання",
    en: "Date of joining",
    hy: "Միանալու ամսաթիվ",
    ka: "გაწევრიანების თარიღი",
  },
};
export const ABSENCE_USER = {
  query: {
    uk: "Запит",
    en: "Request",
    hy: "Հայտ",
    ka: "მოთხოვნა",
  },
  date_from: {
    uk: "Дата з",
    en: "Date from",
    hy: "Ամսաթիվը սկսած",
    ka: "თარიღი დან",
  },
  date_to: {
    uk: "Дата до",
    en: "Date to",
    hy: "Ամսաթիվը մինչև",
    ka: "თარიღი მდე",
  },
  reason: {
    uk: "Причина",
    en: "Reason",
    hy: "Պատճառ",
    ka: "მიზეზი",
  },
  add_btn: {
    uk: "Додати",
    en: "Add",
    hy: "Ավելացնել",
    ka: "დამატება",
  },
  absence_history: {
    uk: "Історія відсутностей",
    en: "Absence history",
    hy: "Բացակայության պատմություն",
    ka: "არყოფნის ისტორია",
  },
  absence_reason: {
    uk: "Будь ласка, введіть причину відсутності",
    en: "Please enter the reason of absence",
    hy: "Խնդրում ենք նշել բացակայության պատճառը",
    ka: "გთხოვთ მიუთითოთ არყოფნის მიზეზი",
  },
  absence_short_reason_title: {
    uk: "Варіанти швидких причин відсутності",
    en: "Quick absence reasons",
    hy: "Բացակայության արագ պատճառներ",
    ka: "არყოფნის სასწრაფო მიზეზები",
  },
  absence_short_reason: {
    uk: "Виберіть швидкий варіант причини відсутності",
    en: "You can choose a quick reason for absence",
    hy: "Դուք կարող եք ընտրել բացակայության արագ պատճառ",
    ka: "შეგიძლიათ აირჩიოთ არყოფნის სასწრაფო მიზეზი",
  },
};
export const WEEK = {
  monday: {
    uk: "Понеділок",
    en: "Monday",
    hy: "Երկուշաբթի",
    ka: "ორშაბათი",
  },
  tuesday: {
    uk: "Вівторок",
    en: "Tuesday",
    hy: "Երեքշաբթի",
    ka: "სამშაბათი",
  },
  wednesday: {
    uk: "Середа",
    en: "Wednesday",
    hy: "Չորեքշաբթի",
    ka: "ოთხშაბათი",
  },
  thursday: {
    uk: "Четвер",
    en: "Thursday",
    hy: "Հինգշաբթի",
    ka: "ხუთშაბათი",
  },
  friday: {
    uk: "Пятниця",
    en: "Friday",
    hy: "Ուրբաթ",
    ka: "პარასკევი",
  },
  saturday: {
    uk: "Субота",
    en: "Saturday",
    hy: "Շաբաթ",
    ka: "შაბათი",
  },
  sunday: {
    uk: "Неділя",
    en: "Sunday",
    hy: "Կիրակի",
    ka: "კვირა",
  },
};
export const TAKS_LIST = {
  point: {
    uk: "Точка",
    en: "Point",
    hy: "Կետ",
    ka: "წერტილი",
  },
  created_by: {
    uk: "Ким створено",
    en: "Created by",
    hy: "Ստեղծված է",
    ka: "შექმნილია",
  },
  supervisor: {
    uk: "Супервайзер",
    en: "Supervisor",
    hy: "Սուպերվայզեր",
    ka: "სუპერვაიზერი",
  },
  merchendiser: {
    uk: "Мерчендайзер",
    en: "Merchendiser",
    hy: "Մերչենդայզեր",
    ka: "მერჩენდაიზერი",
  },
  name: {
    uk: "Назва",
    en: "Name",
    hy: "Անվանում",
    ka: "სახელი",
  },
  task_title: {
    uk: "Титул",
    en: "Title",
    hy: "Վերնագիր",
    ka: "სათაური",
  },
  task_group_points_title: {
    uk: "Титул завантаження",
    en: "Upload title",
    hy: "Վերբեռնման վերնագիր",
    ka: "ჩატვირთვის სათაური",
  },
  finishing: {
    uk: "Закінчення",
    en: "Finishing",
    hy: "Ավարտ",
    ka: "დასრულება",
  },
  status: {
    uk: "Статус",
    en: "Status",
    hy: "Կարգավիճակ",
    ka: "სტატუსი",
  },
  date_creation: {
    uk: "Дата створення",
    en: "Date of creation",
    hy: "Ստեղծման ամսաթիվ",
    ka: "შექმნის თარიღი",
  },
  print_report: {
    uk: "Друкувати звіт",
    en: "Print report",
    hy: "Տպել հաշվետվությունը",
    ka: "ანგარიშის დაბეჭდვა",
  },
  responses: {
    uk: "Відповіді",
    en: "Responses",
    hy: "Պատասխաններ",
    ka: "პასუხები",
  },
  first_page: {
    uk: "Перша",
    en: "First",
    hy: "Առաջին",
    ka: "პირველი",
  },
  previous_page: {
    uk: "Попередня",
    en: "Previous",
    hy: "Նախորդ",
    ka: "წინა",
  },
  next_page: {
    uk: "Наступна",
    en: "Next",
    hy: "Հաջորդ",
    ka: "შემდეგი",
  },
  last_page: {
    uk: "Остання",
    en: "Last",
    hy: "Վերջին",
    ka: "ბოლო",
  },
  description: {
    uk: "Опис",
    en: "Description",
    hy: "Նկարագրություն",
    ka: "აღწერა",
  },
  addresses: {
    uk: "Адреса",
    en: "Addresses",
    hy: "Հասցեներ",
    ka: "მისამართები",
  },
  network: {
    uk: "Мережа",
    en: "Network",
    hy: "Ցանց",
    ka: "ქსელი",
  },
  answer_saved: {
    uk: "Відповідь збережена",
    en: "The answer is saved",
    hy: "Պատասխանը պահպանված է",
    ka: "პასუხი შენახულია",
  },
  task_saved: {
    uk: "Завдання збережене",
    en: "The task is saved",
    hy: "Առաջադրանքը պահպանված է",
    ka: "დავალება შენახულია",
  },
  date_saved: {
    uk: "Дані успішно збережені",
    en: "The data is successfully saved",
    hy: "Տվյալները հաջողությամբ պահպանված են",
    ka: "მონაცემები წარმატებით შენახულია",
  },
  download_btn: {
    uk: "Завантажити",
    en: "Download",
    hy: "Ներբեռնել",
    ka: "ჩამოტვირთვა",
  },
  approv_btn: {
    uk: "Затвердити",
    en: "To approve",
    hy: "Հաստատել",
    ka: "დამტკიცება",
  },
  reject_btn: {
    uk: "Відхилити",
    en: "Reject",
    hy: "Մերժել",
    ka: "უარყოფა",
  },
  remove_btn: {
    uk: "Видалити",
    en: "Remove",
    hy: "Ջնջել",
    ka: "წაშლა",
  },
  cancel_btn: {
    uk: "Відмінити",
    en: "Cancel",
    hy: "Չեղարկել",
    ka: "გაუქმება",
  },
  back_btn: {
    uk: "Назад",
    en: "Back",
    hy: "Հետ",
    ka: "უკან",
  },
  task_details_title: {
    uk: "Деталі завдання",
    en: "Details of the task",
    hy: "Առաջադրանքի մանրամասներ",
    ka: "დავალების დეტალები",
  },
  task_created_by_err_msg: {
    uk: "Видалити завдання може тільки її автор",
    en: "Remove the task can only be done by its author",
    hy: "Առաջադրանքը կարող է ջնջել միայն դրա հեղինակը",
    ka: "დავალების წაშლა შესაძლებელია მხოლოდ მისი ავტორის მიერ",
  },
  new_task_group_btn_text: {
    uk: "На групу точок",
    en: "Per group of points",
    hy: "Կետերի խմբի համար",
    ka: "წერტილების ჯგუფისთვის",
  },
  new_task_single_btn_text: {
    uk: "На точку",
    en: "Per one point",
    hy: "Մեկ կետի համար",
    ka: "ერთი წერტილისთვის",
  },
  yes: {
    uk: "так",
    en: "yes",
    hy: "այո",
    ka: "დიახ",
  },
  no: {
    uk: "ні",
    en: "no",
    hy: "ոչ",
    ka: "არა",
  },
};
export const TAKS_NEW = {
  drag_msg: {
    uk: "Клікніть або перетягніть зображення сюди",
    en: "Click or drag the image here",
    hy: "Սեղմեք կամ քաշեք նկարը այստեղ",
    ka: "დააკლიკეთ ან გადმოათრიეთ სურათი აქ",
  },
  new_order: {
    uk: "Нове доручення",
    en: "New order",
    hy: "Նոր հանձնարարություն",
    ka: "ახალი დავალება",
  },
  group_point_label: {
    uk: "Група точок",
    en: "Group of points",
    hy: "Կետերի խումբ",
    ka: "წერტილების ჯგუფი",
  },
  task_template: {
    uk: "Шаблон",
    en: "Template",
    hy: "Ձևանմուշ",
    ka: "შაბლონი",
  },
  start_date: {
    uk: "Дата початку",
    en: "The start date",
    hy: "Սկզբի ամսաթիվ",
    ka: "დაწყების თარიღი",
  },
  end_date: {
    uk: "Дата закінчення",
    en: "The end date",
    hy: "Ավարտի ամսաթիվ",
    ka: "დასრულების თარიღი",
  },
  save_btn: {
    uk: "Зберегти",
    en: "Save",
    hy: "Պահպանել",
    ka: "შენახვა",
  },
};
export const TAKS_REVIEW = {
  apply_btn: {
    uk: "Застосувати",
    en: "Apply",
    hy: "Կիրառել",
    ka: "გამოყენება",
  },
  reject_btn: {
    uk: "Відхилити",
    en: "Reject",
    hy: "Մերժել",
    ka: "უარყოფა",
  },
  reset_filters_btn: {
    uk: "Скинути фільтри",
    en: "Reset the filters",
    hy: "Զրոյացնել զտիչները",
    ka: "ფილტრების გადატვირთვა",
  },
  records_count: {
    uk: "Кількість записів",
    en: "Records count",
    hy: "Գրառումների քանակ",
    ka: "ჩანაწერების რაოდენობა",
  },
  point: {
    uk: "Точка",
    en: "Point",
    hy: "Կետ",
    ka: "წერტილი",
  },
  network: {
    uk: "Мережа",
    en: "Network",
    hy: "Ցանց",
    ka: "ქსელი",
  },
  priority: {
    uk: "Пріоритет",
    en: "Priority",
    hy: "Առաջնահերթություն",
    ka: "პრიორიტეტი",
  },
  merchandiser: {
    uk: "Мерчендайзер",
    en: "Merchandiser",
    hy: "Մերչենդայզեր",
    ka: "მერჩენდაიზერი",
  },
  responsible_supervisor: {
    uk: "Відповідальний супервайзер",
    en: "Responsible supervisor",
    hy: "Պատասխանատու սուպերվայզեր",
    ka: "პასუხისმგებელი სუპერვაიზერი",
  },
  supervisor: {
    uk: "Супервайзер",
    en: "Supervisor",
    hy: "Սուպերվայզեր",
    ka: "სუპერვაიზერი",
  },
  view_btn: {
    uk: "Перегляд",
    en: "View",
    hy: "Դիտել",
    ka: "ნახვა",
  },
  photo_title: {
    uk: "Фото",
    en: "Photo",
    hy: "Լուսանկար",
    ka: "ფოტო",
  },
  details_task: {
    uk: "Деталі Завдання",
    en: "Details of the task",
    hy: "Առաջադրանքի մանրամասներ",
    ka: "დავალების დეტალები",
  },
  title_task: {
    uk: "Титул",
    en: "Title",
    hy: "Վերնագիր",
    ka: "სათაური",
  },
  description_task: {
    uk: "Опис завдання",
    en: "Description of the task",
    hy: "Առաջադրանքի նկարագրություն",
    ka: "დავალების აღწერა",
  },
  tags_task: {
    uk: "Теги",
    en: "Tags",
    hy: "Թեգեր",
    ka: "ტეგები",
  },
  images_task: {
    uk: "Зображення",
    en: "Images",
    hy: "Նկարներ",
    ka: "სურათები",
  },
  deadline_task: {
    uk: "Дедлайн",
    en: "Deadline",
    hy: "Վերջնաժամկետ",
    ka: "ვადა",
  },
  details_response_task: {
    uk: "Деталі Відповіді",
    en: "Response Details",
    hy: "Պատասխանի մանրամասներ",
    ka: "პასუხის დეტალები",
  },
  date_response_task: {
    uk: "Дата відповіді",
    en: "Response Date",
    hy: "Պատասխանի ամսաթիվ",
    ka: "პასუხის თარიღი",
  },
  text_response_task: {
    uk: "Текст відповіді",
    en: "Response Text",
    hy: "Պատասխանի տեքստ",
    ka: "პასუხის ტექსტი",
  },
  photo_response_task: {
    uk: "Фото відповіді",
    en: "Response Photo",
    hy: "Պատասխանի լուսանկար",
    ka: "პასუხის ფოტო",
  },
  yes: {
    uk: "Так",
    en: "Yes",
    hy: "Այո",
    ka: "დიახ",
  },
  no: {
    uk: "Ні",
    en: "No",
    hy: "Ոչ",
    ka: "არა",
  },
  visit_id: {
    uk: "Номер Візиту",
    en: "Visit ID",
    hy: "Այցի համար",
    ka: "ვიზიტის ID",
  },
  back_btn: {
    uk: "Назад",
    en: "Back",
    hy: "Հետ",
    ka: "უკან",
  },
};
export const TAKS_IMPORT = {
  import_tab: {
    uk: "Імпорт",
    en: "Import",
    hy: "Ներմուծում",
    ka: "იმპორტი",
  },
  import_advanced_tab: {
    uk: "Розширений імпорт",
    en: "Advanced Import",
    hy: "Ընդլայնված ներմուծում",
    ka: "დამატებითი იმპორტი",
  },
  import_matrix_tab: {
    uk: "Імпорт: асортимента матриця",
    en: "Import: Assortment Matrix",
    hy: "Ներմուծում. Տեսականու մատրիցա",
    ka: "იმპორტი: ასორტიმენტის მატრიცა",
  },
  import_downloads_tab: {
    uk: "Мої завантаження",
    en: "My Uploads",
    hy: "Իմ վերբեռնումները",
    ka: "ჩემი ატვირთვები",
  },
  type_loading: {
    uk: "Тип завантаження",
    en: "Loading Type",
    hy: "Բեռնման տեսակ",
    ka: "ჩატვირთვის ტიპი",
  },
  click_or_drag_file: {
    uk: "Клікніть або перетягніть файл",
    en: "Click or Drag a File",
    hy: "Սեղմեք կամ քաշեք ֆայլը",
    ka: "დააჭირეთ ან გადმოათრიეთ ფაილი",
  },
  download_btn: {
    uk: "Завантажити",
    en: "Download",
    hy: "Ներբեռնել",
    ka: "ჩამოტვირთვა",
  },
  add_record_btn: {
    uk: "Додати запис",
    en: "Add Record",
    hy: "Ավելացնել գրառում",
    ka: "ჩანაწერის დამატება",
  },
  save_btn: {
    uk: "Зберегти",
    en: "Save",
    hy: "Պահպանել",
    ka: "შენახვა",
  },
  back_btn: {
    uk: "Назад",
    en: "Back",
    hy: "Հետ",
    ka: "უკან",
  },
  status: {
    uk: "Статус",
    en: "Status",
    hy: "Կարգավիճակ",
    ka: "სტატუსი",
  },
  name_title: {
    uk: "Назва",
    en: "Name",
    hy: "Անուն",
    ka: "სახელი",
  },
  line_title: {
    uk: "Рядок",
    en: "Line",
    hy: "Տող",
    ka: "ხაზი",
  },
  start_date_title: {
    uk: "Дата початку",
    en: "Start Date",
    hy: "Սկզբի ամսաթիվ",
    ka: "დაწყების თარიღი",
  },
  end_date_title: {
    uk: "Дата кінця",
    en: "End Date",
    hy: "Ավարտի ամսաթիվ",
    ka: "დასრულების თარიღი",
  },
  photo_title: {
    uk: "Фото",
    en: "Photo",
    hy: "Լուսանկար",
    ka: "ფოტო",
  },
  description_title: {
    uk: "Опис",
    en: "Description",
    hy: "Նկարագրություն",
    ka: "აღწერა",
  },
  added_points_text_label_suf: {
    uk: "Додано",
    en: "Added",
    hy: "Ավելացվել է",
    ka: "დამატებულია",
  },
  added_points_text_label_pref: {
    uk: "точка(точок)",
    en: "point(points)",
    hy: "կետ(եր)",
    ka: "წერტილი(ები)",
  },
  type_tasks_title: {
    uk: "Тип задач",
    en: "Type of tasks",
    hy: "Առաջադրանքների տեսակ",
    ka: "დავალებების ტიპი",
  },
  download_date_title: {
    uk: "Дата завантаження",
    en: "Download date",
    hy: "Ներբեռնման ամսաթիվ",
    ka: "ჩამოტვირთვის თარიღი",
  },
  loading_errors_title: {
    uk: "Помилки завантаження",
    en: "Loading errors",
    hy: "Բեռնման սխալներ",
    ka: "ჩატვირთვის შეცდომები",
  },
  need_title_task_msg: {
    uk: "Потрібно ввести титул завдання",
    en: "You need to enter the title of the task",
    hy: "Անհրաժեշտ է մուտքագրել առաջադրանքի վերնագիրը",
    ka: "საჭიროა შეიყვანოთ დავალების სათაური",
  },
  download_was_delete_msg: {
    uk: "Завантаження успішно видалено",
    en: "Download has been successfully deleted",
    hy: "Ներբեռնումը հաջողությամբ ջնջվել է",
    ka: "ჩამოტვირთვა წარმატებით წაიშალა",
  },
  need_choose_task_msg: {
    uk: "Потрібно вибрати шаблон",
    en: "You need to choose a template",
    hy: "Անհրաժեշտ է ընտրել ձևանմուշ",
    ka: "საჭიროა შაბლონის არჩევა",
  },
  need_choose_point_msg: {
    uk: "Потрібно вибрати точку",
    en: "Point is required field",
    hy: "Կետը պարտադիր դաշտ է",
    ka: "წერტილი სავალდებულო ველია",
  },
  need_choose_point_group_msg: {
    uk: "Потрібно вибрати групу точок",
    en: "Group of points is required field",
    hy: "Կետերի խումբը պարտադիր դաշտ է",
    ka: "წერტილების ჯგუფი სავალდებულო ველია",
  },
  create_success_group_task_msg: {
    uk: "Ваші завдання створюються та будуть готові за кілька хвилин.",
    en: "Creating your tasks. They will be ready in a couple of minutes.",
    hy: "Ձեր առաջադրանքները ստեղծվում են։ Դրանք պատրաստ կլինեն մի քանի րոպեում։",
    ka: "თქვენი დავალებები იქმნება. ისინი მზად იქნება რამდენიმე წუთში.",
  },
  need_choose_point_group_name_msg: {
    uk: "Потрібно ввести титул завантаження",
    en: "Group of points title is required field",
    hy: "Կետերի խմբի վերնագիրը պարտադիր դաշտ է",
    ka: "წერტილების ჯგუფის სათაური სავალდებულო ველია",
  },
  empty_field_msg: {
    uk: "Це поле не може бути пустим",
    en: "This field cannot be empty",
    hy: "Այս դաշտը չի կարող դատարկ լինել",
    ka: "ეს ველი არ შეიძლება იყოს ცარიელი",
  },
  download_name: {
    uk: "Назва завантаження",
    en: "Download name",
    hy: "Ներբեռնման անվանում",
    ka: "ჩამოტვირთვის სახელი",
  },
  select_download_type: {
    uk: "Оберіть типа завантаження",
    en: "Choose the download type",
    hy: "Ընտրեք ներբեռնման տեսակը",
    ka: "აირჩიეთ ჩამოტვირთვის ტიპი",
  },
  click_drag_img: {
    uk: "Клікніть або перетягніть зображення сюди",
    en: "Click or drag the image here",
    hy: "Սեղմեք կամ քաշեք նկարը այստեղ",
    ka: "დააჭირეთ ან გადმოათრიეთ სურათი აქ",
  },
  only_one_photo_allowed_for_type_point: {
    uk: "Для типу завантаження 'Точка' дозволене лише одне фото",
    en: "For upload type 'Point', only one photo is allowed",
    hy: "«Կետ» տեսակի վերբեռնման համար թույլատրվում է միայն մեկ լուսանկար",
    ka: "'წერტილი' ტიპის ატვირთვისთვის დაშვებულია მხოლოდ ერთი ფოტო",
  },
  complete_at_least_one_task_msg: {
    uk: "Заповніть хоча б одне завдання або виберіть файл для імпорту",
    en: "Complete at least one task or select a file to import",
    hy: "Լրացրեք առնվազն մեկ առաջադրանք կամ ընտրեք ֆայլ ներմուծման համար",
    ka: "შეავსეთ სულ მცირე ერთი დავალება ან აირჩიეთ ფაილი იმპორტისთვის",
  },
  network_label: {
    uk: "Мережа",
    en: "Network",
    hy: "Ցանց",
    ka: "ქსელი",
  },
  point_label: {
    uk: "Точка",
    en: "Point",
    hy: "Կետ",
    ka: "წერტილი",
  },
  remove_btn: {
    uk: "Видалити",
    en: "Remove",
    hy: "Հեռացնել",
    ka: "წაშლა",
  },
  addresses_label: {
    uk: "Адреса",
    en: "Addresses",
    hy: "Հասցեներ",
    ka: "მისამართები",
  },
  code_label: {
    uk: "Код",
    en: "Code",
    hy: "Կոդ",
    ka: "კოდი",
  },
  location_label: {
    uk: "Розташування",
    en: "Location",
    hy: "Գտնվելու վայր",
    ka: "მდებარეობა",
  },
  coordinates_label: {
    uk: "Координати",
    en: "Coordinates",
    hy: "Կոորդինատներ",
    ka: "კოორდინატები",
  },
  view_the_point: {
    uk: "Перегляд точки",
    en: "View the point",
    hy: "Դիտել կետը",
    ka: "წერტილის ნახვა",
  },
  grouping_btn_name: {
    uk: "Групування",
    en: "Grouping",
    hy: "Խմբավորում",
    ka: "დაჯგუფება",
  },
  new_group_btn_name: {
    uk: "Нова група",
    en: "New Group",
    hy: "Նոր խումբ",
    ka: "ახალი ჯგუფი",
  },
  grouping_popup_title: {
    uk: "Групування торгових точок",
    en: "Grouping of trade points",
    hy: "Առևտրի կետերի խմբավորում",
    ka: "სავაჭრო წერტილების დაჯგუფება",
  },
  new_group_popup_title: {
    uk: "Існуючі групи",
    en: "Existing groups",
    hy: "Առկա խմբեր",
    ka: "არსებული ჯგუფები",
  },
  new_group_popup_new_title: {
    uk: "Створення нової групи",
    en: "Creating a new group",
    hy: "Նոր խմբի ստեղծում",
    ka: "ახალი ჯგუფის შექმნა",
  },
  new_group_popup_edit_title: {
    uk: "Редагування групи",
    en: "Editing group",
    hy: "Խմբի խմբագրում",
    ka: "ჯგუფის რედაქტირება",
  },
  new_group_popup_field_name: {
    uk: "Назва групи",
    en: "Group Name",
    hy: "Խմբի անվանում",
    ka: "ჯგუფის სახელი",
  },
  new_group_popup_field_group_textarea_name: {
    uk: "Торгові точки",
    en: "Trade points",
    hy: "Առևտրի կետեր",
    ka: "სავაჭრო წერტილები",
  },
  group_popup_filter_name_label: {
    uk: "Фільтр точок",
    en: "Points filter",
    hy: "Կետերի ֆիլտր",
    ka: "წერტილების ფილტრი",
  },
  new_group_popup_field_group_available_users: {
    uk: "Доступно для",
    en: "Available for",
    hy: "Հասանելի է",
    ka: "ხელმისაწვდომია",
  },
  new_group_popup_field_name_placeholder: {
    uk: "Введіть назву групи. Мінімум 5 символів",
    en: "Enter the name of the group. Minimum 5 characters",
    hy: "Մուտքագրեք խմբի անվանումը։ Առնվազն 5 նշան",
    ka: "შეიყვანეთ ჯგუფის სახელი. მინიმუმ 5 სიმბოლო",
  },
  group_popup_filter_name_placeholder: {
    uk: "Фільтрування торгових точок (мін 3 символи)",
    en: "Filtering trade points (min 3 characters)",
    hy: "Առևտրի կետերի զտում (նվազագույնը 3 նշան)",
    ka: "სავაჭრო წერტილების ფილტრაცია (მინ. 3 სიმბოლო)",
  },
  new_group_popup_field_group_add_all_btn_text: {
    uk: "Додати всі точки",
    en: "Add all points",
    hy: "Ավելացնել բոլոր կետերը",
    ka: "ყველა წერტილის დამატება",
  },
  new_group_popup_field_group_placeholder: {
    uk: "Виберіть торгові точки зі списку",
    en: "Choose trade points from the list",
    hy: "Ընտրեք առևտրի կետերը ցանկից",
    ka: "აირჩიეთ სავაჭრო წერტილები სიიდან",
  },
  group_popup_filter_name_empty_placeholder: {
    uk: "Торгових точок що відповідають вашому фільтру не знайдено",
    en: "No trade points matching your filter were found.",
    hy: "Ձեր ֆիլտրին համապատասխանող առևտրի կետեր չեն գտնվել։",
    ka: "თქვენი ფილტრის შესატყვისი სავაჭრო წერტილები არ მოიძებნა.",
  },
  new_group_popup_field_users_placeholder: {
    uk: "Виберіть кому доступна група зі списку",
    en: "Choose who has access to the group from the list",
    hy: "Ընտրեք ցանկից, ում համար հասանելի է խումբը",
    ka: "აირჩიეთ სიიდან, ვისთვისაც ხელმისაწვდომია ჯგუფი",
  },
  new_group_popup_error_text: {
    uk: "Поле не може бути пустим",
    en: "The field cannot be empty",
    hy: "Դաշտը չի կարող դատարկ լինել",
    ka: "ველი არ შეიძლება იყოს ცარიელი",
  },
  new_group_popup_error_text_minimum: {
    uk: "Мінімум 5 символів",
    en: "Minimum 5 characters",
    hy: "Առնվազն 5 նշան",
    ka: "მინიმუმ 5 სიმბოლო",
  },
  new_group_popup_success_save_text: {
    uk: "Успішно збережено",
    en: "Successfully saved",
    hy: "Հաջողությամբ պահպանվել է",
    ka: "წარმატებით შეინახა",
  },
  new_group_popup_success_deleted_text: {
    uk: "Успішно видалено",
    en: "Successfully deleted",
    hy: "Հաջողությամբ ջնջվել է",
    ka: "წარმატებით წაიშალა",
  },
  new_group_popup_failed_deleted_text: {
    uk: "Помилка видалення, дивіться деталі в консолі",
    en: "Failed to delete, check the console",
    hy: "Ջնջումը ձախողվեց, ստուգեք console-ը",
    ka: "წაშლა ვერ მოხერხდა, გადაამოწმეთ კონსოლი",
  },
  new_group_popup_user_validate_error_text: {
    uk: "У вас немає дозволу для виконання цієї дії",
    en: "You do not have permission to perform this action.",
    hy: "Դուք չունեք այս գործողությունը կատարելու թույլտվություն։",
    ka: "თქვენ არ გაქვთ ამ მოქმედების შესრულების უფლება.",
  },
  new_group_popup_error_save_text: {
    uk: "Помилка створення нової группи",
    en: "Error creating a new group",
    hy: "Սխալ նոր խումբ ստեղծելիս",
    ka: "შეცდომა ახალი ჯგუფის შექმნისას",
  },
  new_group_popup_error_update_text: {
    uk: "Помилка оновлення группи",
    en: "Error updating group",
    hy: "Սխալ խումբը թարմացնելիս",
    ka: "შეცდომა ჯგუფის განახლებისას",
  },
  new_group_popup_delete_approve_text: {
    uk: "Ви впевнені, що хочете видалити?",
    en: "Are you sure you want to delete?",
    hy: "Համոզված եք, որ ուզում եք ջնջել?",
    ka: "დარწმუნებული ხართ, რომ გსურთ წაშლა?",
  },
  new_group_popup_btn_save_name: {
    uk: "Зберегти",
    en: "Save",
    hy: "Պահպանել",
    ka: "შენახვა",
  },
  no_group_found_msg: {
    uk: "Жодна група не знайдена",
    en: "No group found",
    hy: "Խումբ չի գտնվել",
    ka: "ჯგუფი არ მოიძებნა",
  },
  selected_point_row_has_error: {
    uk: "При виборі точки виникла помилка",
    en: "An error occurred while selecting the point",
    hy: "Կետը ընտրելիս սխալ տեղի ունեցավ",
    ka: "წერტილის არჩევისას მოხდა შეცდომა",
  },
  file_successfully_uploaded: {
    uk: "Файл успішно завантажений",
    en: "File Successfully Uploaded",
    hy: "Ֆայլը հաջողությամբ վերբեռնվեց",
    ka: "ფაილი წარმატებით აიტვირთა",
  },
  file_error_uploaded: {
    uk: "Виникла помилка при загрузці файла",
    en: "An error occurred while loading the file.",
    hy: "Ֆայլը բեռնելիս սխալ տեղի ունեցավ։",
    ka: "ფაილის ჩატვირთვისას მოხდა შეცდომა.",
  },
  import_group_dragdrop_label: {
    uk: "Клікніть або перетягніть файл сюди або виберіть торгові точки зі списку",
    en: "Click or drag the file here or select the trade points from the list",
    hy: "Սեղմեք կամ քաշեք ֆայլը այստեղ, կամ ընտրեք առևտրի կետերը ցանկից",
    ka: "დააჭირეთ ან გადმოათრიეთ ფაილი აქ, ან აირჩიეთ სავაჭრო წერტილები სიიდან",
  },
  import_group_dragdrop_approve_file_text: {
    uk: "Тільки .csv,.xlsx файл",
    en: "Only .csv,.xlsx file",
    hy: "Միայն .csv, .xlsx ֆայլ",
    ka: "მხოლოდ .csv, .xlsx ფაილი",
  },
  confirm_clear_all_points_before_change: {
    uk: "Ви додали всі поінти. Очистити список та продовжити? (ОК — очистити, Скасувати — залишити)",
    en: "You added all points. Clear the list and proceed? (OK — clear, Cancel — keep)",
    hy: "Դուք ավելացրել եք բոլոր կետերը։ Մաքրել ցանկը և շարունակել։ (OK — մաքրել, Չեղարկել — պահել)",
    ka: "თქვენ დაამატეთ ყველა წერტილი. გავასუფთაოთ სია და გავაგრძელოთ? (OK — გასუფთავება, გაუქმება — შენარჩუნება)",
  },
  confirm_reset_or_keep_points: {
    uk: "В списку є вибрані поінти. Додати нові до існуючих? (ОК — додати до існуючих, Скасувати — скинути)",
    en: "Points exist in the list. Add new ones to existing? (OK — add to existing, Cancel — reset)",
    hy: "Ցանկում կան ընտրված կետեր։ Ավելացնել նորերը գոյություն ունեցողներին։ (OK — ավելացնել առկաներին, Չեղարկել — զրոյացնել)",
    ka: "სიაში არსებობს არჩეული წერტილები. დავამატოთ ახლები არსებულებთან? (OK — დამატება არსებულთან, გაუქმება — გადაყენება)",
  },
  confirm_clear_all_points_before_change: {
    uk: "Ви додали всі поінти. Очистити список та продовжити? (ОК — очистити, Скасувати — залишити)",
    en: "You added all points. Clear the list and proceed? (OK — clear, Cancel — keep)",
    hy: "Դուք ավելացրել եք բոլոր կետերը։ Մաքրել ցանկը և շարունակել։ (OK — մաքրել, Չեղարկել — պահել)",
    ka: "თქვენ დაამატეთ ყველა წერტილი. გავასუფთაოთ სია და გავაგრძელოთ? (OK — გასუფთავება, გაუქმება — შენარჩუნება)",
  },
  confirm_reset_or_keep_points: {
    uk: "В списку є вибрані поінти. Додати нові до існуючих? (ОК — додати до існуючих, Скасувати — скинути)",
    en: "Points exist in the list. Add new ones to existing? (OK — add to existing, Cancel — reset)",
    hy: "Ցանկում կան ընտրված կետեր։ Ավելացնել նորերը գոյություն ունեցողներին։ (OK — ավելացնել առկաներին, Չեղարկել — զրոյացնել)",
    ka: "სიაში არსებობს არჩეული წერტილები. დავამატოთ ახლები არსებულებთან? (OK — დამატება არსებულთან, გაუქმება — გადაყენება)",
  },
};
export const DOCUMENTS = {
  file_deleted: {
    uk: "Файл видалений",
    en: "File Deleted",
    hy: "Ֆայլը ջնջված է",
    ka: "ფაილი წაშლილია",
  },
  file_name_cannot_be_empty: {
    uk: "Ім'я файлу не може бути пустим",
    en: "File Name Cannot Be Empty",
    hy: "Ֆայլի անունը չի կարող դատարկ լինել",
    ka: "ფაილის სახელი არ შეიძლება იყოს ცარიელი",
  },
  need_to_add_file: {
    uk: "Потрібно додати файл",
    en: "Need to Add File",
    hy: "Անհրաժեշտ է ավելացնել ֆայլ",
    ka: "საჭიროა ფაილის დამატება",
  },
  file_successfully_uploaded: {
    uk: "Файл успішно завантажений",
    en: "File Successfully Uploaded",
    hy: "Ֆայլը հաջողությամբ վերբեռնվեց",
    ka: "ფაილი წარმატებით აიტვირთა",
  },
  add_file: {
    uk: "Додати файл",
    en: "Add File",
    hy: "Ավելացնել ֆայլ",
    ka: "ფაილის დამატება",
  },
  file_name: {
    uk: "Назва файлу",
    en: "File Name",
    hy: "Ֆայլի անուն",
    ka: "ფაილის სახელი",
  },
  click_or_drag_files_here: {
    uk: "Клікніть або перетягніть файли сюди",
    en: "Click or Drag Files Here",
    hy: "Սեղմեք կամ քաշեք ֆայլերը այստեղ",
    ka: "დააჭირეთ ან გადმოათრიეთ ფაილები აქ",
  },
  download_file_btn: {
    uk: "Завантажити файл",
    en: "Download File",
    hy: "Ներբեռնել ֆայլը",
    ka: "ფაილის ჩამოტვირთვა",
  },
  creation_time: {
    uk: "Час створення",
    en: "Creation Time",
    hy: "Ստեղծման ժամանակ",
    ka: "შექმნის დრო",
  },
  search: {
    uk: "Пошук",
    en: "Search",
    hy: "Որոնում",
    ka: "ძებნა",
  },
};
export const PHOTO_REVIEW = {
  merchendiser: {
    uk: "Мерчендайзер",
    en: "Merchendiser",
    hy: "Մերչենդայզեր",
    ka: "მერჩენდაიზერი",
  },
  responsible_supervisor: {
    uk: "Відповідальний супервайзер",
    en: "Responsible supervisor",
    hy: "Պատասխանատու վերակացու",
    ka: "პასუხისმგებელი სუპერვაიზერი",
  },
  start_visit: {
    uk: "Старт візиту",
    en: "The start of the visit",
    hy: "Այցի սկիզբը",
    ka: "ვიზიტის დაწყება",
  },
  end_visit: {
    uk: "Кінець візиту",
    en: "The end of the visit",
    hy: "Այցի ավարտը",
    ka: "ვიზიტის დასასრული",
  },
  comment: {
    uk: "Коментар",
    en: "Comment",
    hy: "Մեկնաբանություն",
    ka: "კომენტარი",
  },
  price: {
    uk: "Ціна",
    en: "Price",
    hy: "Գին",
    ka: "ფასი",
  },
  sales_price: {
    uk: "Ціна продажу",
    en: "Sales price",
    hy: "Վաճառքի գին",
    ka: "გაყიდვის ფასი",
  },
  price_monitoring: {
    uk: "Моніторинг цін",
    en: "Price monitoring",
    hy: "Գների մոնիտորինգ",
    ka: "ფასების მონიტორინგი",
  },
  approve_reject_label_block: {
    uk: "Статус затвердження/відхилення",
    en: "Approval/Rejection Status",
    hy: "Հաստատման/մերժման կարգավիճակ",
    ka: "დამტკიცების/უკუქცევის სტატუსი",
  },
  approv_btn: {
    uk: "Затвердити",
    en: "To approve",
    hy: "Հաստատել",
    ka: "დამტკიცება",
  },
  reject_btn: {
    uk: "Відхилити",
    en: "Reject",
    hy: "Մերժել",
    ka: "უკუქცევა",
  },
  approved_by: {
    uk: "Затверджено",
    en: "Approved by",
    hy: "Հաստատված է՝",
    ka: "დამტკიცებულია",
  },
  rejected_by: {
    uk: "Відхилено",
    en: "Rejected by",
    hy: "Մերժված է՝",
    ka: "უკუქცეულია",
  },
  app_reject_date: {
    uk: "Дата",
    en: "Date",
    hy: "Ամսաթիվ",
    ka: "თარიღი",
  },
  answer: {
    uk: "Відповідь",
    en: "Answer",
    hy: "Պատասխան",
    ka: "პასუხი",
  },
  linkedTasks: {
    uk: "Повязані задачі",
    en: "Linked tasks",
    hy: "Կապակցված առաջադրանքներ",
    ka: "დაკავშირებული დავალებები",
  },
  linkedVisit: {
    uk: "Візит",
    en: "Visit",
    hy: "Այց",
    ka: "ვიზიტი",
  },
  description: {
    uk: "Опис",
    en: "Description",
    hy: "Նկարագրություն",
    ka: "აღწერა",
  },
  yes: {
    uk: "Так",
    en: "Yes",
    hy: "Այո",
    ka: "დიახ",
  },
  no: {
    uk: "Ні",
    en: "No",
    hy: "Ոչ",
    ka: "არა",
  },
  created_by: {
    uk: "Ким створено",
    en: "Created by",
    hy: "Ստեղծված է՝",
    ka: "შექმნილია",
  },
  priority: {
    uk: "Пріорітет",
    en: "Priority",
    hy: "Առաջնահերթություն",
    ka: "პრიორიტეტი",
  },
  status: {
    uk: "Статус",
    en: "Status",
    hy: "Կարգավիճակ",
    ka: "სტატუსი",
  },
  approved: {
    uk: "Затверджено",
    en: "Approved",
    hy: "Հաստատված",
    ka: "დამტკიცებული",
  },
  rejected: {
    uk: "Відхілено",
    en: "Rejected",
    hy: "Մերժված",
    ka: "უკუქცეული",
  },
};
export const USER_LOGIN = {
  login_success_msg: {
    uk: "Ви успішно увійшли в систему",
    en: "You have successfully logged in to the system",
    hy: "Դուք հաջողությամբ մուտք գործեցիք համակարգ",
    ka: "თქვენ წარმატებით შეხვედით სისტემაში",
  },
  login_error_msg: {
    uk: "Користувач не існує або неправильні дані для входу.",
    en: "User does not exist or incorrect login data.",
    hy: "Օգտատերը գոյություն չունի կամ մուտքի տվյալները սխալ են։",
    ka: "მომხმარებელი არ არსებობს ან შესვლის მონაცემები არასწორია.",
  },
};
export const VISIT_PAGE = {
  page_title: {
    uk: "Візити",
    en: "Visits",
    hy: "Այցեր",
    ka: "ვიზიტები",
  },
  table_timespent: {
    uk: "Час",
    en: "Time",
    hy: "Ժամանակ",
    ka: "დრო",
  },
  author_way: {
    uk: "Автор/По маршруту",
    en: "Author/On the route",
    hy: "Հեղինակ/Երթուղով",
    ka: "ავტორი/მარშრუტზე",
  },
  merchandiser: {
    uk: "Мерчендайзер",
    en: "Merchandiser",
    hy: "Մերչենդայզեր",
    ka: "მერჩენდაიზერი",
  },
  supervisor: {
    uk: "Супервайзер",
    en: "Supervisor",
    hy: "Վերակացու",
    ka: "სუპერვაიზერი",
  },
  approved_by: {
    uk: "Затверджено",
    en: "Approved by",
    hy: "Հաստատված է՝",
    ka: "დამტკიცებულია",
  },
  point: {
    uk: "Точка",
    en: "Point",
    hy: "Կետ",
    ka: "წერტილი",
  },
  point_started_title: {
    uk: "Розпочато",
    en: "Started",
    hy: "Սկսված է",
    ka: "დაწყებულია",
  },
  point_agoby_title: {
    uk: "тому",
    en: "ago by",
    hy: "առաջ՝",
    ka: "წინ",
  },
  seconds: {
    uk: "секунд",
    en: "seconds",
    hy: "վայրկյան",
    ka: "წამი",
  },
  minutes: {
    uk: "хвилин",
    en: "minutes",
    hy: "րոպե",
    ka: "წუთი",
  },
  hours: {
    uk: "годин",
    en: "hours",
    hy: "ժամ",
    ka: "საათი",
  },
  days: {
    uk: "днів",
    en: "days",
    hy: "օր",
    ka: "დღე",
  },
  months: {
    uk: "місяців",
    en: "months",
    hy: "ամիս",
    ka: "თვე",
  },
  years: {
    uk: "років",
    en: "years",
    hy: "տարի",
    ka: "წელი",
  },
  status_label: {
    uk: "Статус",
    en: "Status",
    hy: "Կարգավիճակ",
    ka: "სტატუსი",
  },
  progress_label: {
    uk: "Прогрес, %",
    en: "Progress, %",
    hy: "Առաջընթաց, %",
    ka: "პროგრესი, %",
  },
  approved_label_popup: {
    uk: "Затверджено",
    en: "Approved",
    hy: "Հաստատված",
    ka: "დამტკიცებული",
  },
  pending_label_popup: {
    uk: "На затверджені",
    en: "Pending",
    hy: "Սպասման մեջ",
    ka: "მოლოდინში",
  },
  rejected_label_popup: {
    uk: "Не виконані",
    en: "Not executed",
    hy: "Չկատարված",
    ka: "შეუსრულებელი",
  },
  approved_single_visit_name: {
    uk: "Затверджено",
    en: "Approved",
    hy: "Հաստատված",
    ka: "დამტკიცებული",
  },
  no_approved_single_visit_name: {
    uk: "Не затверджено",
    en: "Not approved",
    hy: "Չհաստատված",
    ka: "დაუმტკიცებელი",
  },
  on_verification_single_visit_name: {
    uk: "На перевірці",
    en: "On verification",
    hy: "Ստուգման փուլում",
    ka: "გადამოწმებაში",
  },
  back_to_btn_label: {
    uk: "Повернутися до візитів",
    en: "Back to visits",
    hy: "Վերադառնալ այցերին",
    ka: "დაბრუნება ვიზიტებზე",
  },
  orders_tab_name: {
    uk: "Замовлення",
    en: "Orders",
    hy: "Պատվերներ",
    ka: "შეკვეთები",
  },
  returns_tab_name: {
    uk: "Повернення",
    en: "Returns",
    hy: "Վերադարձներ",
    ka: "დაბრუნებები",
  },
  payments_tab_name: {
    uk: "Платежі",
    en: "Payments",
    hy: "Վճարումներ",
    ka: "გადახდები",
  },
  zvit_tab_name: {
    uk: "Звіти",
    en: "Reports",
    hy: "Հաշվետվություններ",
    ka: "ანგარიშები",
  },
  task_tab_name: {
    uk: "Задачі",
    en: "Tasks",
    hy: "Առաջադրանքներ",
    ka: "დავალებები",
  },
  monitoring_tab_name: {
    uk: "Моніторинг",
    en: "Monitoring",
    hy: "Մոնիտորինգ",
    ka: "მონიტორინგი",
  },
  log_tab_name: {
    uk: "Журнал подій",
    en: "Event log",
    hy: "Իրադարձությունների մատյան",
    ka: "ივენთების ჟურნალი",
  },
  surveys_tab_name: {
    uk: "Опитування",
    en: "Surveys",
    hy: "Հարցումներ",
    ka: "გამოკითხვები",
  },
  surveys_summary_surveys_label: {
    uk: "Опитування",
    en: "Surveys",
    hy: "Հարցումներ",
    ka: "გამოკითხვები",
  },
  surveys_summary_answers_label: {
    uk: "Відповіді",
    en: "Answers",
    hy: "Պատասխաններ",
    ka: "პასუხები",
  },
  surveys_summary_photos_label: {
    uk: "Фото",
    en: "Photos",
    hy: "Լուսանկարներ",
    ka: "ფოტოები",
  },
  surveys_tab_products: {
    uk: "Товари",
    en: "Products",
    hy: "Ապրանքներ",
    ka: "პროდუქტები",
  },
  surveys_tab_brands: {
    uk: "Бренди",
    en: "Brands",
    hy: "Բրենդներ",
    ka: "ბრენდები",
  },
  surveys_tab_categories: {
    uk: "Категорії",
    en: "Categories",
    hy: "Կատեգորիաներ",
    ka: "კატეგორიები",
  },
  surveys_tab_other: {
    uk: "Інше",
    en: "Other",
    hy: "Այլ",
    ka: "სხვა",
  },
  surveys_answer_type_bool: {
    uk: "Так/Ні",
    en: "Bool",
    hy: "Այո/Ոչ",
    ka: "დიახ/არა",
  },
  surveys_answer_type_numeric: {
    uk: "Число",
    en: "Numeric",
    hy: "Թվային",
    ka: "რიცხვითი",
  },
  surveys_answer_type_dropdown: {
    uk: "Список",
    en: "Dropdown",
    hy: "Ցանկ",
    ka: "სია",
  },
  surveys_answer_type_text: {
    uk: "Текст",
    en: "Text",
    hy: "Տեքստ",
    ka: "ტექსტი",
  },
  surveys_answer_type_date: {
    uk: "Дата",
    en: "Date",
    hy: "Ամսաթիվ",
    ka: "თარიღი",
  },
  surveys_answer_type_photo: {
    uk: "Фото",
    en: "Photo",
    hy: "Լուսանկար",
    ka: "ფოტო",
  },
  surveys_answer_bool_yes: {
    uk: "Так",
    en: "Yes",
    hy: "Այո",
    ka: "დიახ",
  },
  surveys_answer_bool_no: {
    uk: "Ні",
    en: "No",
    hy: "Ոչ",
    ka: "არა",
  },
  surveys_photo_label: {
    uk: "фото",
    en: "photos",
    hy: "լուսանկար",
    ka: "ფოტო",
  },
  surveys_empty_products: {
    uk: "Немає питань по товарах",
    en: "No product questions",
    hy: "Ապրանքների վերաբերյալ հարցեր չկան",
    ka: "პროდუქტის კითხვები არ არის",
  },
  surveys_empty_brands: {
    uk: "Немає питань по брендах",
    en: "No brand questions",
    hy: "Բրենդների վերաբերյալ հարցեր չկան",
    ka: "ბრენდის კითხვები არ არის",
  },
  surveys_empty_categories: {
    uk: "Немає питань по категоріях",
    en: "No category questions",
    hy: "Կատեգորիաների վերաբերյալ հարցեր չկան",
    ka: "კატეგორიის კითხვები არ არის",
  },
  surveys_empty_other: {
    uk: "Немає інших питань",
    en: "No other questions",
    hy: "Այլ հարցեր չկան",
    ka: "სხვა კითხვები არ არის",
  },
  surveys_modal_close: {
    uk: "Закрити",
    en: "Close",
    hy: "Փակել",
    ka: "დახურვა",
  },
  surveys_search_placeholder: {
    uk: "Пошук опитування…",
    en: "Search survey…",
    hy: "Փնտրել հարցում…",
    ka: "გამოკითხვის ძებნა…",
  },
  surveys_reset_btn: {
    uk: "Скинути",
    en: "Reset",
    hy: "Զրոյացնել",
    ka: "გადაყენება",
  },
  surveys_entity_search_placeholder: {
    uk: "Пошук…",
    en: "Search…",
    hy: "Փնտրել…",
    ka: "ძებნა…",
  },
  surveys_no_results: {
    uk: "Нічого не знайдено за запитом",
    en: "No results found",
    hy: "Արդյունքներ չեն գտնվել",
    ka: "შედეგები არ მოიძებნა",
  },
  surveys_show_more: {
    uk: "Показати ще",
    en: "Show more",
    hy: "Ցույց տալ ավելին",
    ka: "მეტის ჩვენება",
  },
  task_has_empty_error: {
    uk: "Будь ласка, виберіть хоча б один ітем",
    en: "Please select at least one item",
    hy: "Խնդրում ենք ընտրել առնվազն մեկ միավոր",
    ka: "გთხოვთ, აირჩიოთ მინიმუმ ერთი ერთეული",
  },
  task_has_answer_error: {
    uk: "Задача немає відповіді",
    en: "The task has no answer",
    hy: "Առաջադրանքը պատասխան չունի",
    ka: "დავალებას პასუხი არ აქვს",
  },
  approv_task_product_btn: {
    uk: "Затвердити продукт",
    en: "To approve the product",
    hy: "Հաստատել ապրանքը",
    ka: "პროდუქტის დამტკიცება",
  },
  reject_task_product_btn: {
    uk: "Відхилити продукт",
    en: "Reject the product",
    hy: "Մերժել ապրանքը",
    ka: "პროდუქტის უკუქცევა",
  },
  approv_task_btn: {
    uk: "Затвердити задачу",
    en: "To approve the task",
    hy: "Հաստատել առաջադրանքը",
    ka: "დავალების დამტკიცება",
  },
  reject_task_btn: {
    uk: "Відхилити задачу",
    en: "Reject the task",
    hy: "Մերժել առաջադրանքը",
    ka: "დავალების უკუქცევა",
  },
  approv_btn: {
    uk: "Затвердити",
    en: "To approve",
    hy: "Հաստատել",
    ka: "დამტკიცება",
  },
  reject_btn: {
    uk: "Відхилити",
    en: "Reject",
    hy: "Մերժել",
    ka: "უკუქცევა",
  },
  task_tab_type_label: {
    uk: "Тип",
    en: "Type",
    hy: "Տեսակ",
    ka: "ტიპი",
  },
  task_tab_task_name_label: {
    uk: "Назва задачі",
    en: "Name of the task",
    hy: "Առաջադրանքի անվանում",
    ka: "დავალების სახელი",
  },
  task_tab_info_label: {
    uk: "Опис",
    en: "Description",
    hy: "Նկարագրություն",
    ka: "აღწერა",
  },
  task_tab_deadline_label: {
    uk: "Дедлайн",
    en: "Deadline",
    hy: "Վերջնաժամկետ",
    ka: "დედლაინი",
  },
  task_tab_createdby_label: {
    uk: "Ким створено",
    en: "Created by",
    hy: "Ստեղծված է՝",
    ka: "შექმნილია",
  },
  task_tab_count_photo_label: {
    uk: "Кількість фото",
    en: "Number of photos",
    hy: "Լուսանկարների քանակ",
    ka: "ფოტოების რაოდენობა",
  },
  task_tab_status_label: {
    uk: "Статус",
    en: "Status",
    hy: "Կարգավիճակ",
    ka: "სტატუსი",
  },
  task_tab_answer_status_yes_label: {
    uk: "Так",
    en: "Yes",
    hy: "Այո",
    ka: "დიახ",
  },
  task_tab_answer_status_no_label: {
    uk: "Ні",
    en: "No",
    hy: "Ոչ",
    ka: "არა",
  },
  task_tab_answer_status_label: {
    uk: "Відповідь",
    en: "Answer",
    hy: "Պատասխան",
    ka: "პასუხი",
  },
  task_tab_answer_comment_label: {
    uk: "Коментар",
    en: "Comment ",
    hy: "Մեկնաբանություն",
    ka: "კომენტარი",
  },
  task_tab_answer_tags_label: {
    uk: "Теги",
    en: "Tags ",
    hy: "Թեգեր",
    ka: "თეგები",
  },
  approve_visit_msg: {
    uk: "Візит затверджено",
    en: "Visit approved",
    hy: "Այցը հաստատված է",
    ka: "ვიზიტი დამტკიცებულია",
  },
  already_approve_visit_msg: {
    uk: "Візит вже було затверджено",
    en: "Visit already approved",
    hy: "Այցն արդեն հաստատված է",
    ka: "ვიზიტი უკვე დამტკიცებულია",
  },
  reject_visit_msg: {
    uk: "Візит відхилено",
    en: "Visit rejected",
    hy: "Այցը մերժված է",
    ka: "ვიზიტი უკუქცეულია",
  },
  already_reject_visit_msg: {
    uk: "Візит вже було відхилено",
    en: "Visit already rejected",
    hy: "Այցն արդեն մերժված է",
    ka: "ვიზიტი უკვე უკუქცეულია",
  },
  monitoring_tab_pname_label: {
    uk: "Назва",
    en: "Name",
    hy: "Անվանում",
    ka: "სახელი",
  },
  monitoring_tab_pcode_label: {
    uk: "Код продукту",
    en: "Product code",
    hy: "Ապրանքի կոդ",
    ka: "პროდუქტის კოდი",
  },
  monitoring_tab_price_label: {
    uk: "Ціна",
    en: "Price",
    hy: "Գին",
    ka: "ფასი",
  },
  monitoring_tab_sale_price_label: {
    uk: "Ціна продажу",
    en: "Sale Price",
    hy: "Վաճառքի գին",
    ka: "გაყიდვის ფასი",
  },
  monitoring_tab_photo_label: {
    uk: "Фото",
    en: "Photo URL",
    hy: "Լուսանկարի հղում",
    ka: "ფოტოს URL",
  },
  monitoring_tab_comment_label: {
    uk: "Коментар",
    en: "Comment",
    hy: "Մեկնաբանություն",
    ka: "კომენტარი",
  },
  monitoring_tab_event_monitoring_label: {
    uk: "Моніторинг",
    en: "Monitoring",
    hy: "Մոնիտորինգ",
    ka: "მონიტორინგი",
  },
  monitoring_tab_event_photos_in_answers_label: {
    uk: "Фото у відповідях",
    en: "Photos in answers",
    hy: "Լուսանկարներ պատասխաններում",
    ka: "ფოტოები პასუხებში",
  },
  monitoring_tab_event_photos_in_reports_label: {
    uk: "Фото у звітах",
    en: "Photos in reports",
    hy: "Լուսանկարներ հաշվետվություններում",
    ka: "ფოტოები ანგარიშებში",
  },
  monitoring_tab_event_reports_done_label: {
    uk: "Звітів виконано",
    en: "Reports done",
    hy: "Կատարված հաշվետվություններ",
    ka: "შესრულებული ანგარიშები",
  },
  monitoring_tab_event_tasks_done_label: {
    uk: "Завдань виконано",
    en: "Tasks done",
    hy: "Կատարված առաջադրանքներ",
    ka: "შესრულებული დავალებები",
  },
  monitoring_tab_event_tasks_not_done_label: {
    uk: "Завдань не виконано",
    en: "Tasks not done",
    hy: "Չկատարված առաջադրանքներ",
    ka: "შეუსრულებელი დავალებები",
  },
  monitoring_tab_event_answers_not_supervised_label: {
    uk: "Відповідей не перевірено",
    en: "Answers not supervised",
    hy: "Չվերստուգված պատասխաններ",
    ka: "შეუმოწმებელი პასუხები",
  },
  monitoring_tab_event_answers_supervised_label: {
    uk: "Відповідей перевірено",
    en: "Answers supervised",
    hy: "Վերստուգված պատասխաններ",
    ka: "შემოწმებული პასუხები",
  },
  monitoring_tab_selected_label: {
    uk: "Обрано",
    en: "Selected",
    hy: "Ընտրված",
    ka: "შერჩეული",
  },
  orders_product_name: {
    uk: "Назва замовлення",
    en: "Order Name",
    hy: "Պատվերի անվանում",
    ka: "შეკვეთის სახელი",
  },
  orders_product_status_changed: {
    uk: "Статус змінено",
    en: "Status changed ",
    hy: "Կարգավիճակը փոխվել է",
    ka: "სტატუსი შეიცვალა",
  },
  orders_product_status_date: {
    uk: "Дата",
    en: "Date",
    hy: "Ամսաթիվ",
    ka: "თარიღი",
  },
  orders_product_status: {
    uk: "Статус",
    en: "Status ",
    hy: "Կարգավիճակ",
    ka: "სტატუსი",
  },
  orders_product_total: {
    uk: "Всього",
    en: "Total ",
    hy: "Ընդամենը",
    ka: "ჯამი",
  },
  orders_currency_total: {
    uk: "грн.",
    en: "grn.",
    hy: "գրն.",
    ka: "გრნ.",
  },
  orders_popup_order_id_title: {
    uk: "ID замовлення",
    en: "Order ID",
    hy: "Պատվերի ID",
    ka: "შეკვეთის ID",
  },
  orders_popup_details_title: {
    uk: "Деталі замовлення",
    en: "Order details",
    hy: "Պատվերի մանրամասներ",
    ka: "შეკვეთის დეტალები",
  },
  orders_popup_sales_rep_label: {
    uk: "Торговий представник",
    en: "Sales Rep",
    hy: "Վաճառքի ներկայացուցիչ",
    ka: "გაყიდვების წარმომადგენელი",
  },
  orders_popup_order_status_label: {
    uk: "Статус замовлення",
    en: "Order Status",
    hy: "Պատվերի կարգավիճակ",
    ka: "შეკვეთის სტატუსი",
  },
  orders_popup_counterparty_label: {
    uk: "Контрагент",
    en: "Counterparty",
    hy: "Կոնտրագենտ",
    ka: "კონტრაგენტი",
  },
  orders_popup_order_type_label: {
    uk: "Тип замовлення",
    en: "Order Type",
    hy: "Պատվերի տեսակ",
    ka: "შეკვეთის ტიპი",
  },
  orders_popup_order_table_label: {
    uk: "Таблиця продуктів",
    en: "Products Table",
    hy: "Ապրանքների աղյուսակ",
    ka: "პროდუქტების ცხრილი",
  },
  orders_popup_order_table_name: {
    uk: "Назва",
    en: "Name",
    hy: "Անվանում",
    ka: "სახელი",
  },
  orders_popup_order_table_quantity: {
    uk: "Кількість",
    en: "Quantity",
    hy: "Քանակ",
    ka: "რაოდენობა",
  },
  orders_popup_order_table_amount: {
    uk: "Сума",
    en: "Amount",
    hy: "Գումար",
    ka: "თანხა",
  },
  orders_popup_created_time_label: {
    uk: "Дата та час створення",
    en: "Created Date & Time",
    hy: "Ստեղծման ամսաթիվ և ժամ",
    ka: "შექმნის თარიღი და დრო",
  },
  orders_popup_delivery_time_label: {
    uk: "Дата доставки",
    en: "Delivery Date",
    hy: "Առաքման ամսաթիվ",
    ka: "მიწოდების თარიღი",
  },
  orders_popup_tracked_geolocation_label: {
    uk: "Відстежена геолокація",
    en: "Tracked Geolocation",
    hy: "Հետագծված աշխարհագրական դիրք",
    ka: "თრექინგის გეოლოკაცია",
  },
  orders_popup_custom_fields_label: {
    uk: "Користувацькі поля",
    en: "Custom Fields",
    hy: "Հատուկ դաշտեր",
    ka: "დამატებითი ველები",
  },
  orders_popup_comment_label: {
    uk: "Коментар",
    en: "Comment",
    hy: "Մեկնաբանություն",
    ka: "კომენტარი",
  },
  orders_popup_visit_label: {
    uk: "Візит",
    en: "Visit",
    hy: "Այց",
    ka: "ვიზიტი",
  },
  orders_physical_return_label: {
    uk: "Дата фізичного повернення",
    en: "Physical Return Date",
    hy: "Ֆիզիկական վերադարձի ամսաթիվ",
    ka: "ფიზიკური დაბრუნების თარიღი",
  },
  orders_status_return_label: {
    uk: "Статус повернення",
    en: "Return Status",
    hy: "Վերադարձի կարգավիճակ",
    ka: "დაბრუნების სტატუსი",
  },
  orders_return_id_label: {
    uk: "ID повернення",
    en: "Return ID",
    hy: "Վերադարձի ID",
    ka: "დაბრუნების ID",
  },
  orders_return_crated_label: {
    uk: "Дата та час створення",
    en: "Created Date & Time",
    hy: "Ստեղծման ամսաթիվ և ժամ",
    ka: "შექმნის თარიღი და დრო",
  },
  orders_payment_id_label: {
    uk: "ID оплати",
    en: "Payment ID",
    hy: "Վճարման ID",
    ka: "გადახდის ID",
  },
  orders_payment_amount_label: {
    uk: "Сума",
    en: "Amount",
    hy: "Գումար",
    ka: "თანხა",
  },
  orders_payment_debt_label: {
    uk: "Борг",
    en: "Debt",
    hy: "Պարտք",
    ka: "დავალიანება",
  },
};
export const POINTS_ADMIN = {
  // section + generic
  section_points: {
    uk: "Точки",
    en: "Points",
    hy: "Կետեր",
    ka: "წერტილები",
  },
  new_btn: {
    uk: "Додати",
    en: "New",
    hy: "Նոր",
    ka: "ახალი",
  },
  save_btn: {
    uk: "Зберегти",
    en: "Save",
    hy: "Պահպանել",
    ka: "შენახვა",
  },
  delete_btn: {
    uk: "Видалити",
    en: "Delete",
    hy: "Ջնջել",
    ka: "წაშლა",
  },
  back_btn: {
    uk: "Назад",
    en: "Back",
    hy: "Հետ",
    ka: "უკან",
  },
  edit_btn: {
    uk: "Редагувати",
    en: "Edit",
    hy: "Խմբագրել",
    ka: "რედაქტირება",
  },
  view_btn: {
    uk: "Перегляд",
    en: "View",
    hy: "Դիտել",
    ka: "ნახვა",
  },
  search_ph: {
    uk: "Пошук",
    en: "Search",
    hy: "Որոնում",
    ka: "ძებნა",
  },
  confirm_delete: {
    uk: "Видалити цей запис?",
    en: "Delete this record?",
    hy: "Ջնջել այս գրառումը?",
    ka: "წავშალო ეს ჩანაწერი?",
  },
  saved: {
    uk: "Збережено",
    en: "Saved",
    hy: "Պահպանված է",
    ka: "შენახულია",
  },
  save_error: {
    uk: "Помилка збереження",
    en: "Error while saving",
    hy: "Պահպանման սխալ",
    ka: "შენახვის შეცდომა",
  },
  deleted: {
    uk: "Видалено",
    en: "Deleted",
    hy: "Ջնջված է",
    ka: "წაშლილია",
  },
  empty: {
    uk: "Немає даних",
    en: "No data",
    hy: "Տվյալներ չկան",
    ka: "მონაცემები არ არის",
  },
  required: {
    uk: "Обов'язкове поле",
    en: "Required",
    hy: "Պարտադիր դաշտ",
    ka: "სავალდებულო ველი",
  },
  // shared field labels
  f_name: {
    uk: "Назва",
    en: "Name",
    hy: "Անվանում",
    ka: "სახელი",
  },
  f_code: {
    uk: "Код",
    en: "Code",
    hy: "Կոդ",
    ka: "კოდი",
  },
  f_image: {
    uk: "Зображення",
    en: "Image",
    hy: "Նկար",
    ka: "სურათი",
  },
  f_logo: {
    uk: "Логотип",
    en: "Logo",
    hy: "Լոգո",
    ka: "ლოგო",
  },
  f_address: {
    uk: "Адреса",
    en: "Address",
    hy: "Հասցե",
    ka: "მისამართი",
  },
  f_network: {
    uk: "Мережа",
    en: "Network",
    hy: "Ցանց",
    ka: "ქსელი",
  },
  f_category: {
    uk: "Категорія",
    en: "Category",
    hy: "Կատեգորիա",
    ka: "კატეგორია",
  },
  f_country: {
    uk: "Країна",
    en: "Country",
    hy: "Երկիր",
    ka: "ქვეყანა",
  },
  f_county: {
    uk: "Регіон",
    en: "County",
    hy: "Մարզ",
    ka: "რეგიონი",
  },
  f_locality: {
    uk: "Населений пункт",
    en: "Locality",
    hy: "Բնակավայր",
    ka: "დასახლებული პუნქტი",
  },
  f_location: {
    uk: "Координати",
    en: "Coordinates",
    hy: "Կոորդինատներ",
    ka: "კოორდინატები",
  },
  f_lat: {
    uk: "Широта",
    en: "Latitude",
    hy: "Լայնություն",
    ka: "განედი",
  },
  f_lng: {
    uk: "Довгота",
    en: "Longitude",
    hy: "Երկայնություն",
    ka: "გრძედი",
  },
  f_minutes: {
    uk: "Рекомендовані хвилини",
    en: "Recommended minutes",
    hy: "Առաջարկվող րոպեներ",
    ka: "რეკომენდებული წუთები",
  },
  f_merchandiser: {
    uk: "Мерчендайзер",
    en: "Merchandiser",
    hy: "Մերչենդայզեր",
    ka: "მერჩენდაიზერი",
  },
  f_supervisors: {
    uk: "Супервайзери",
    en: "Supervisors",
    hy: "Սուպերվայզերներ",
    ka: "სუპერვაიზერები",
  },
  f_is_active: {
    uk: "Активна",
    en: "Active",
    hy: "Ակտիվ",
    ka: "აქტიური",
  },
  f_available_tasks: {
    uk: "Доступна для завдань",
    en: "Available for tasks",
    hy: "Հասանելի է առաջադրանքների համար",
    ka: "ხელმისაწვდომია დავალებებისთვის",
  },
  f_additional_info: {
    uk: "Додаткова інформація",
    en: "Additional info",
    hy: "Լրացուցիչ տեղեկություններ",
    ka: "დამატებითი ინფორმაცია",
  },
  filter_created_by_me: {
    uk: "Створені мною",
    en: "Created by me",
    hy: "Իմ ստեղծած",
    ka: "ჩემ მიერ შექმნილი",
  },
  kv_key: {
    uk: "Мітка",
    en: "Label",
    hy: "Պիտակ",
    ka: "იარლიყი",
  },
  kv_value: {
    uk: "Значення",
    en: "Value",
    hy: "Արժեք",
    ka: "მნიშვნელობა",
  },
  kv_add: {
    uk: "Додати поле",
    en: "Add field",
    hy: "Ավելացնել դաշտ",
    ka: "ველის დამატება",
  },
  f_price_monitoring: {
    uk: "Моніторинг цін",
    en: "Price monitoring",
    hy: "Գների մոնիտորինգ",
    ka: "ფასების მონიტორინგი",
  },
  f_pm_components: {
    uk: "Компоненти моніторингу",
    en: "Price monitoring components",
    hy: "Գների մոնիտորինգի բաղադրիչներ",
    ka: "ფასების მონიტორინგის კომპონენტები",
  },
  f_pm_required: {
    uk: "Обов'язкові компоненти",
    en: "Required components",
    hy: "Պարտադիր բաղադրիչներ",
    ka: "სავალდებული კომპონენტები",
  },
  f_send_outforz: {
    uk: "Надсилати в Outforz",
    en: "Send to Outforz",
    hy: "Ուղարկել Outforz",
    ka: "გაგზავნა Outforz-ში",
  },
  f_auto_approve: {
    uk: "Автозатвердження звітів",
    en: "Auto-approve reports",
    hy: "Հաշվետվությունների ավտոհաստատում",
    ka: "ანგარიშების ავტომატური დამტკიცება",
  },
  f_status_outforz: {
    uk: "Статус для Outforz",
    en: "Status to send to Outforz",
    hy: "Կարգավիճակ Outforz-ին ուղարկելու համար",
    ka: "სტატუსი Outforz-ში გასაგზავნად",
  },
  f_default_tags: {
    uk: "Теги за замовчуванням",
    en: "Default tags",
    hy: "Կանխադրված թեգեր",
    ka: "ნაგულისხმევი ტეგები",
  },
  f_created_by: {
    uk: "Створив",
    en: "Created by",
    hy: "Ստեղծող",
    ka: "შემქმნელი",
  },
  f_available_supervisors: {
    uk: "Доступно супервайзерам",
    en: "Available for supervisors",
    hy: "Հասանելի սուպերվայզերներին",
    ka: "ხელმისაწვდომია სუპერვაიზერებისთვის",
  },
  f_points: {
    uk: "Точки",
    en: "Points",
    hy: "Կետեր",
    ka: "წერტილები",
  },
  // per-entity title keys
  networks_title: {
    uk: "Мережі",
    en: "Networks",
    hy: "Ցանցեր",
    ka: "ქსელები",
  },
  countries_title: {
    uk: "Країни",
    en: "Countries",
    hy: "Երկրներ",
    ka: "ქვეყნები",
  },
  counties_title: {
    uk: "Регіони",
    en: "Counties",
    hy: "Մարզեր",
    ka: "რეგიონები",
  },
  localities_title: {
    uk: "Населені пункти",
    en: "Localities",
    hy: "Բնակավայրեր",
    ka: "დასახლებული პუნქტები",
  },
  categories_title: {
    uk: "Категорії точок",
    en: "Point categories",
    hy: "Կետերի կատեգորիաներ",
    ka: "წერტილების კატეგორიები",
  },
  points_title: {
    uk: "Точки",
    en: "Points",
    hy: "Կետեր",
    ka: "წერტილები",
  },
  point_groups_title: {
    uk: "Групи точок",
    en: "Point groups",
    hy: "Կետերի խմբեր",
    ka: "წერტილების ჯგუფები",
  },
  // status pill
  active: {
    uk: "Активна",
    en: "Active",
    hy: "Ակտիվ",
    ka: "აქტიური",
  },
  inactive: {
    uk: "Неактивна",
    en: "Inactive",
    hy: "Ոչ ակտիվ",
    ka: "არააქტიური",
  },
  f_status: {
    uk: "Статус",
    en: "Status",
    hy: "Կարգավիճակ",
    ka: "სტატუსი",
  },
  activate_btn: {
    uk: "Активувати",
    en: "Activate",
    hy: "Ակտիվացնել",
    ka: "გააქტიურება",
  },
  deactivate_btn: {
    uk: "Деактивувати",
    en: "Deactivate",
    hy: "Դեակտիվացնել",
    ka: "დეაქტივაცია",
  },
  confirm_deactivate: {
    uk: "Деактивувати цей запис?",
    en: "Deactivate this record?",
    hy: "Դեակտիվացնել այս գրառումը?",
    ka: "დეაქტივირება ამ ჩანაწერისთვის?",
  },
  // form sections
  sec_basic: {
    uk: "Основне",
    en: "Basic info",
    hy: "Հիմնական տվյալներ",
    ka: "ძირითადი ინფორმაცია",
  },
  sec_location: {
    uk: "Розташування",
    en: "Location",
    hy: "Տեղադրություն",
    ka: "მდებარეობა",
  },
  sec_assignment: {
    uk: "Відповідальні",
    en: "Assignment",
    hy: "Հանձնարարություն",
    ka: "დანიშვნა",
  },
  sec_options: {
    uk: "Параметри",
    en: "Options",
    hy: "Ընտրանքներ",
    ka: "პარამეტრები",
  },
  // location picker
  search_address: {
    uk: "Пошук адреси",
    en: "Search address",
    hy: "Հասցեի որոնում",
    ka: "მისამართის ძებნა",
  },
  search_btn: {
    uk: "Знайти",
    en: "Search",
    hy: "Փնտրել",
    ka: "ძებნა",
  },
  searching: {
    uk: "Пошук…",
    en: "Searching…",
    hy: "Որոնում…",
    ka: "იძებნება…",
  },
  not_found: {
    uk: "Не знайдено",
    en: "Not found",
    hy: "Չի գտնվել",
    ka: "არ მოიძებნა",
  },
  remove_image: {
    uk: "Видалити",
    en: "Remove",
    hy: "Հեռացնել",
    ka: "წაშლა",
  },
  crop_confirm: {
    uk: "Обрізати",
    en: "Crop",
    hy: "Կտրել",
    ka: "მოჭრა",
  },
  crop_cancel: {
    uk: "Скасувати",
    en: "Cancel",
    hy: "Չեղարկել",
    ka: "გაუქმება",
  },
  // personnel management
  merchandisers_title: {
    uk: "Мерчендайзери",
    en: "Merchandisers",
    hy: "Մերչենդայզերներ",
    ka: "მერჩენდაიზერები",
  },
  supervisors_title: {
    uk: "Супервайзери",
    en: "Supervisors",
    hy: "Սուպերվայզերներ",
    ka: "სუპერვაიზერები",
  },
  f_phone: {
    uk: "Телефон",
    en: "Phone",
    hy: "Հեռախոս",
    ka: "ტელეფონი",
  },
  f_movement: {
    uk: "Пересування",
    en: "Movement",
    hy: "Տեղաշարժ",
    ka: "გადაადგილება",
  },
  f_first_name: {
    uk: "Ім'я",
    en: "First name",
    hy: "Անուն",
    ka: "სახელი",
  },
  f_last_name: {
    uk: "Прізвище",
    en: "Last name",
    hy: "Ազգանուն",
    ka: "გვარი",
  },
};
